import { DailyProgramCta } from '@go-shared/types/dailyProgram';
import { BubbleButton, BubbleFormGroup, BubbleInput } from '@go-client/components/BubbleUI';
import React from 'react';

interface CallToActionsProps {
  readOnly?: boolean;
  callToActions: DailyProgramCta[];
  onUpdate: (callToActions: DailyProgramCta[]) => void;
}

export const CallToActions: React.FC<CallToActionsProps> = ({
  readOnly,
  callToActions,
  onUpdate,
}: CallToActionsProps) => {
  return (
    <fieldset disabled={readOnly}>
      <div className="grid grid-cols-1 gap-3" style={{ justifyItems: 'flex-start' }}>
        {(callToActions || []).map((cta, i) => (
          <div key={i} className="w-full flex items-center">
            <BubbleFormGroup label="Link*" className="flex-grow mr-3">
              <BubbleInput
                type="text"
                block
                value={cta.link}
                onValue={val => {
                  const newCta = { ...callToActions[i] };
                  newCta.link = val;
                  const newVal = [...callToActions];
                  newVal.splice(i, 1, newCta);
                  onUpdate(newVal);
                }}
              />
            </BubbleFormGroup>
            <div className="flex-grow flex items-center">
              <BubbleFormGroup label="Label" className="flex-grow mr-3">
                <BubbleInput
                  type="text"
                  block
                  value={cta.label}
                  onValue={val => {
                    const newCta = { ...callToActions[i] };
                    newCta.label = val;
                    const newVal = [...callToActions];
                    newVal.splice(i, 1, newCta);
                    onUpdate(newVal);
                  }}
                />
              </BubbleFormGroup>
              <BubbleFormGroup label="New Tab">
                <BubbleInput
                  type="checkbox"
                  checked={cta.target === '_blank'}
                  onValue={chk => {
                    const newCta = { ...callToActions[i] };
                    newCta.target = chk ? '_blank' : '';
                    const newVal = [...callToActions];
                    newVal.splice(i, 1, newCta);
                    onUpdate(newVal);
                  }}
                />
              </BubbleFormGroup>

              {!readOnly && (
                <BubbleButton
                  style={{ alignSelf: 'end' }}
                  variant="crimson"
                  inverse
                  icon="trash-alt"
                  onClick={() => {
                    const newVal = [...callToActions];
                    newVal.splice(i, 1);
                    onUpdate(newVal);
                  }}
                />
              )}
            </div>
          </div>
        ))}

        {readOnly && !callToActions.length && (
          <span>No Call to Actions</span>
        )}

        {!readOnly && (
          <>
            <BubbleButton
              variant="navy"
              inverse
              className="p-0-i my-2"
              onClick={() => onUpdate([...callToActions, { link: '', label: '', target: '_blank' }])}
              icon="plus"
            >
              Add Call to Action
            </BubbleButton>
            {(callToActions || []).length > 0 && (
              <div className="text-xs text-slate italic">
                *Ensure links start with http:// or https:// if you intend the link to take the guest to a
                different web page. You may also create links to email or phone by using their respective
                addresses. For example, mailto:johndoe@example.com will open the guest's email client to
                send an email to johndoe@example.com. Likewise, tel:123-456-7890 will open the guest's
                phone book to call 123-456-7890.
              </div>
            )}
          </>
        )}
      </div>
    </fieldset>
  );
};
